export default "__VITE_ASSET__BFAsSVxa__"